import { getVtxToken } from '@vtx/utils';

export const getImgUrl = id => {
    if (!id) {
        return {
            src: '',
            thumb: '',
        };
    }
    const token = getVtxToken('token');
    return {
        src: `/cloudFile/common/downloadFile?id=${id}&token=${token || ''}`,
        thumb: `/vortex/rest/cloud/np/file/downloadFileThumbnail?id=${id}&token=${token ||
            ''}&scale=0.4&outputQuality=0.3`,
    };
};
